namespace Portico.Models.Enterprise {
    import psge = apigateway.enums;
    import psgm = apigateway.models;

    export interface IEmailAddress {
        id: number;
        type: number | string;
        address: string;
        language: string;
    }

    export class EmailAddress implements IEmailAddress {
        id: number;
        type: number | string;
        address: string;
        language: string;

        constructor(obj?: IEmailAddress | any) {
            this.id = null;
            this.type = null;
            this.address = '';
            this.language = '';

            if (obj) {
				this.id = obj.id || obj.emailAddressId || null;
				this.type = obj.type || obj.emailAddressType || null;
				this.address = obj.address || '';
                this.language = obj.language || '';
            }
        }

        mapToEnterpriseCoordinatorEmailAddress() : psgm.EnterpriseCoordinatorSharedEmailAddressUpsearchModel {
            return {
                emailAddressId: this.id,
                emailAddressType: typeof this.type === 'number' ? this.type : psge.RoleType[this.type],
                address: this.address,
                language: this.language
            } as psgm.EnterpriseCoordinatorSharedEmailAddressUpsearchModel
        }
    }
}
